/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Pagina niet gevonden",
  "ComingSoon": "Binnenkort beschikbaar",
  "YesanPersonalFinance": "Yesan, Persoonlijke financiën",
  "Yesan": "Yesan",
  "PersonalFinance": "Persoonlijke Financiën",
  "YesanDownload": "Yesan downloaden",
  "ThisWebsiteUsesCookies": "We gebruiken cookies om informatie over de prestaties en het gebruik van onze site te verzamelen en te analyseren, en om functies voor sociale media te bieden. Door verder te gaan, stemt u in met onze",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Word financieel vrij",
  "inStepsAndActions": "in 8 stappen en 3 acties.",
  "TrackPlanAnalyze": "Volgen. Plan. Analyseer.",
  "FTrack": "1. Volg",
  "FPlan": "2. Plan",
  "FAnalyze": "3. Analyseren",
  "Features": "Kenmerken",
  "FeaturesSubHeading": "Pure beginner, al financieel onderlegd, dit is de app die je nodig hebt om financieel vrij te worden.",
  "ManageAccounts": "Rekeningen beheren",
  "CashLiquidFixedAssetsLiabilities": "Geldmiddelen, liquide middelen, vaste activa en schulden.",
  "TrackTransactions": "Transacties bijhouden",
  "IncomesExpensesTransferInvestments": "Inkomsten, uitgaven, overboekingen, investeringen.",
  "ImportExport": "Importeren/exporteren",
  "YourDataAlwaysAccessible": "Uw gegevens altijd toegankelijk.",
  "PlanYourFreedom": "Plan je vrijheid",
  "StepsAwayFromFI": "8 stappen verwijderd van financiële onafhankelijkheid.",
  "BudgetsAndGoals": "Budgetten & Doelen",
  "CheckYourProgressAndAchieve": "Controleer je vooruitgang en bereik je financiële doelen.",
  "DashboardAndAnalytics": "Dashboard & Analytics",
  "ReviewLearnOptimizeWith": "Bekijk, leer en optimaliseer met grafieken, inzichten en tools.",
  "Security": "Beveiliging",
  "MilitaryGradeEncryption": "Militaire encryptie, ondersteuning voor biometrie, gegevens opgeslagen op je apparaten.",
  "OfflineMode": "Offline modus",
  "YourDataAlwaysAccessibleAndModif": "Uw gegevens altijd toegankelijk en aanpasbaar.",
  "Track": "Volg",
  "Income": "Inkomen",
  "Expense": "Onkosten",
  "Transfer": "overmaken",
  "transactionsAndManageAccounts": "transacties en beheer verschillende rekeningen:",
  "checkings": "Controleren",
  "savings": "Spaarrekening",
  "realEstate": "Onroerend goed",
  "stocks": "Aandelen",
  "bonds": "Obligaties",
  "crypto": "Crypto",
  "notes": "Biljetten, Portefeuille",
  "envelopes": "Enveloppen",
  "privateEquity": "Privé vermogen",
  "metal": "Metaal",
  "retirement": "Pensioen",
  "lifeInsurance": "Levensverzekering",
  "intellectualProperty": "Intellectueel eigendom",
  "otherLiquidAsset": "Andere liquide middelen",
  "otherFixedAsset": "Andere vaste activa",
  "mortgage": "Hypotheek",
  "loan": "Consumentenlening",
  "creditCard": "Kredietkaart",
  "otherLiability": "Andere aansprakelijkheid",
  "AccountsManagement": "Rekeningen beheer",
  "MultipleAccountsTypesAndGrouping": "Meerdere soorten rekeningen en groepering",
  "LinkAccounts": "Rekeningen van uw instellingen koppelen (alleen beschikbaar in bepaalde landen)",
  "SmartAccounts": "Slimme rekeningen",
  "AddEditDeleteTransactions": "Transacties toevoegen / bewerken / verwijderen",
  "TickVerifiedTransactions": "Geverifieerde transacties aanvinken",
  "CategorizeTransactions": "Transacties categoriseren",
  "TagTransactions": "Transacties taggen",
  "TrackKakeiboType": "Type Kakeibo volgen",
  "TrackInvestments": "Investeringen bijhouden (alleen beschikbaar in bepaalde landen)",
  "ImportFromCSVFile": "Transacties volledig of stapsgewijs importeren vanuit CSV-bestand",
  "ExportToCSVFile": "Transacties exporteren naar CSV-bestand",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 stappen naar financiële onafhankelijkheid plan, gedetailleerde budgettering, bereik je financiële doelen sneller.",
  "levelsTowardsFI": "8 niveaus op weg naar financiële onafhankelijkheid",
  "EstablishBudgetsPer": "Budgetten opstellen per",
  "account": "rekening",
  "accountType": "type rekening",
  "KakeiboType": "Kakeibo type",
  "category": "categorie",
  "tag": "label",
  "label": "label",
  "TrackBudgetsPerFrequency": "Budgetten bijhouden per frequentie",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Maak doelen op uitgaven, saldo, cashflow, acties",
  "TrackGoalsProgress": "Volg de voortgang van doelen",
  "ReviewLearnOptimizeWithReportsCharts": "Beoordelen, leren, optimaliseren met rapporten, grafieken, trends, inzichten, tools.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Financiële overzichten: Netto Waarde",
  "FSPnL": "Financiële overzichten: Inkomstenrekening / Winst & Verlies",
  "FSBalanceSheetAssetsLiabilities": "Financiële overzichten: Balans, activa, passiva",
  "FSCashFlow": "Financiële overzichten: Kasstroomoverzicht, Debet Credit, Stromen",
  "FSFlows": "Financiële overzichten: Stromen",
  "FSRatios": "Financiële overzichten: Verhoudingsgetallen",
  "TrendsMonthEnd": "Maandelijkse trends: Inkomsten & uitgaven, kasstroom",
  "TrendsPerformance": "Rendementstrends: Jaar, maand, week",
  "IncomeTrendsPer": "Inkomenstrends per",
  "SpendingTrendsPer": "Uitgaven trends per",
  "RecurringItemsIE": "Terugkerende items: Inkomsten & Uitgaven",
  "DebtProgressTrends": "Schuld Voortgang trends",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD overzicht, laatste maand, trends",
  "FIWCLE": "Financiële onafhankelijkheid: Muurgrafiek, uitgaven per levensenergie",
  "DebtPaydownSnowballAvalanche": "Schuld aflossen: Sneeuwbal, Lawine",
  "FullyCustomizableAnalyticsRange": "Volledig aanpasbaar analytisch tijdbereik",
  "ContactUs": "Neem contact met ons op",
  "Privacy": "Privacy",
  "Terms": "Voorwaarden",
  "About": "Over",
  "IAgreeToThe": "Ik ga akkoord met de",
  "AndThe": "en de",
  "PrivacyPolicy": "Privacybeleid",
  "TermsOfUse": "Gebruiksvoorwaarden",

  "DigitalSoftwareExperienceTagline": "Digitale software-ervaring voor de moderne wereld",
  "DigitalExperience": "Digitale ervaring",
  "SoftwareForTheModernWorld": "Software voor de moderne wereld",
  "MobileApplications": "Mobiele toepassingen",
  "forConnectedAndOfflineHumans": "voor verbonden en offline mensen",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Responsive en webservices",
  "PersonalFinanceServices": "Persoonlijke financiële diensten",
  "YS_p1": "Yesan is een dynamisch softwarebedrijf gespecialiseerd in de ontwikkeling van geavanceerde mobiele applicaties op maat voor consumenten. Yesan heeft een goed begrip van de veranderende behoeften en voorkeuren van de hedendaagse technisch onderlegde gebruikers en is toegewijd aan het ontwikkelen van intuïtieve, boeiende en functierijke mobiele ervaringen die het leven van de gebruikers verrijken.",
  "YS_p2": "De kern van Yesan's missie is een niet aflatende toewijding aan innovatie en creativiteit, elk product is zorgvuldig ontworpen om naadloze functionaliteit en een uitzonderlijke gebruikerservaring te leveren.",
  "PersonalFinanceApplication": "Persoonlijke Financiën Applicatie",
  "YPF_p1": "Yesan, Personal Finance is een geavanceerde mobiele applicatie voor persoonlijke financiën, ontworpen om gebruikers te voorzien van uitgebreide financiële management tools die gemakkelijk toegankelijk zijn binnen handbereik. Met een gestroomlijnde en intuïtieve interface biedt Yesan, Personal Finance een holistische benadering van financieel beheer, voor gebruikers van alle niveaus van financiële kennis.",
  "YPF_p2": "Tot de belangrijkste functies behoren het bijhouden van budgetten, het categoriseren van uitgaven en het in realtime volgen van transacties, zodat gebruikers moeiteloos inzicht krijgen in hun bestedingsgewoonten. De app biedt ook aanpasbare budgetteringsopties, zodat gebruikers financiële doelen kunnen stellen en hun voortgang in de loop van de tijd kunnen volgen.",
  "YPF_p3": "Yesan, Personal Finance geeft bovendien prioriteit aan beveiliging en maakt gebruik van geavanceerde encryptieprotocollen om de gevoelige financiële informatie van gebruikers te beschermen. Dankzij de beveiligingsmaatregelen op bankniveau kunnen gebruikers met een gerust hart hun rekeningen koppelen en transacties synchroniseren zonder dat dit ten koste gaat van hun privacy.",
  "YPF_p4": "Yesan, Personal Finance gaat verder dan basis budgettering door inzichtelijke analyses en gepersonaliseerde aanbevelingen te bieden om financiële beslissingen te optimaliseren. Of het nu gaat om het identificeren van potentiële besparingsmogelijkheden, het bewaken van beleggingsportefeuilles of het beheren van schuldaflossingsstrategieën, de app biedt inzichten op maat om gebruikers te helpen hun financiële doelen te bereiken.",
  "Discover": "Ontdek",
  "Firstname": "Voornaam",
  "Lastname": "Achternaam",
  "Company":"Bedrijf",
  "Subject": "Onderwerp",
  "Email": "E-mail",
  "Message": "Bericht",
  "ThankYouForContactingUs": "Bedankt voor uw contact",
  "ValidFirstnameRequired": "Geldige voornaam is vereist.",
  "ValidLastnameRequired": "Geldige achternaam is vereist.",
  "ValidEmailAddressRequired": "Voer een geldig e-mailadres in.",
  "ValidSubjectRequired": "Selecteer een geldig onderwerp.",
  "ValidMessageRequired": "Voer een geldig bericht in.",
  "UnableToSendTheFormPleaseRetryLater": "Kan het formulier niet verzenden, probeer het later opnieuw.",
  "Information": "Informatie",
  "Sales":"Verkoop",
  "Support": "Ondersteuning",
  "Press": "Pers",
  "Partnership": "Partners",
  "Other": "Andere",
  "Blog":"Blog",

  "Accept":"Accepteer",
  "Decline":"Weigeren",

  "WorklogCalendar":"Werklogboekkalender voor Jira",

  "DirectlyAccessibleInProjectApps":"Direct toegankelijk in project-apps",
  "VisualizeWhereYouSpentYourTime":"Visualiseer waar je je tijd hebt doorgebracht",
  "AllYourWorklogsInACalendar":"Al je werklogs in een kalender",
  "MonthSummary":"Maandoverzicht",
  "CheckIfYouForgotToLogTime":"Controleer of je tijd bent vergeten te loggen.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Direct toegang tot de kwesties en tijd bijwerken",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klik op het werklog item om direct naar de kwesties te gaan en je bijgehouden tijd te bewerken",
  "AlsoAvailableInDarkMode":"Ook beschikbaar in donkere modus",
  "DirectlyLogWorkOnTheCalendarVisually":"Log werk direct visueel in op de kalender",
  "ClickOnTheCalendarToCreateNewWorklog":"Klik op de kalender om een nieuwe werklog aan te maken",

  "AppsForAtlassian":"Apps voor Atlassian",
  "YCL_p1":"Visualiseer al je werklogs op een kalender met maand-, week-, werkweek- en dagweergaven.",
  "YCL_p2":"Log werk direct vanuit de kalender door visueel het tijdslot te selecteren.",
  "YCL_p3":"Identificeer als je vergeten bent tijd bij te houden voor je timesheets.",
  "YCL_p4":"Beschikbaar in jouw taal: Engels (VK), Engels (VS), Chinees (Vereenvoudigd), Chinees (Traditioneel), Tsjechisch, Deens, Nederlands, Ests, Fins, Frans, Duits, Hongaars, IJslands, Italiaans, Japans, Koreaans, Noors, Pools, Portugees (Brazilië), Portugees (Portugal), Russisch, Spaans, Zweeds, Turks.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Financiële portfolio voor Jira",
  "BringRealFinancialPortfolio":"Breng echt financieel portfoliomanagement naar Jira. Houd budgetten, CapEx/OpEx en projectkosten op één plek bij.",
  "YFPAboutQ":"Hoeveel kosten onze Jira-projecten ons nu eigenlijk?",
  "YFPAbout":"Financiële portfolio voor Jira\nFinanciële leiders en PMO's worstelen met het beantwoorden van een simpele vraag:\nHoeveel kosten onze Jira-projecten ons echt?\nJira houdt het werk bij.\nFinanciën houdt de budgetten bij.\nDeze app verbindt deze twee eindelijk met elkaar.\n\nFinanciële portfolio verandert Jira in een lichtgewicht PPM + financieel planningsplatform — zonder dat er dure bedrijfstools nodig zijn.",
  "YFPPorfolioQ":"Portfoliobudgetten & tracking",
  "YFPPorfolioP":"Maak portfolio's aan voor meerdere Jira-projecten en definieer: budgetbedrag, valuta, datumbereik, opgenomen projecten, teams. Volg de werkelijke kosten automatisch terwijl het werk in Jira plaatsvindt.",
  "YFPPorfolioListQ":"Portfolio's",
  "YFPPorfolioListP":"Maak financiële portfolio's die meerdere Jira-projecten combineren en zie direct: budget versus werkelijke kosten, realtime projectverbruik, uitsplitsing van CapEx versus OpEx, kosten per issue en project, exporteerbare financiële rapporten. Dit alles wordt rechtstreeks aangedreven door Jira-werklogs.",
  "CostQ":"Automatische kostenberekening",
  "CostP":"Zet tijdregistratie om in echte financiële gegevens. De app: leest Jira-werklogboeken, past uurtarieven toe, berekent dagelijks de werkelijke projectkosten. Geen spreadsheets. Geen handmatig werk.",
  "RatesQ":"Tarieven",
  "RatesP":"Stel uurtarieven in per project, team of globaal",
  "ReportQ":"Financiële rapportage in CSV",
  "ReportP":"Exporteer financiële portfoliogegevens in enkele seconden. Perfect voor: financiële teams, CFO-rapportage, budgetplanning, ondersteuning bij audits",
  "SettingsQ":"CapEx versus OpEx-classificatie",
  "SettingsP":"Ondersteuning van boekhoud- en auditvereisten. Classificeer werk in: activeerbare ontwikkeling (CapEx), operationeel werk (OpEx). Genereer exporteerbare rapporten die klaar zijn voor financiële teams."
};

export const documents = {
};
